module.exports = __webpack_public_path__ + "static/img/xd.26f3ac0b.svg";